module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-Italic.woff2?dfadecc879b7e0c10e7abd15e7f46375";